export default __webpack_public_path__ + "static/media/1.f089a596.png";